import { formatShortDateWithWeekday } from "@clipboard-health/date-time";
import { Stack } from "@mui/material";
import { Card, Text } from "@src/appV2/redesign/system/ui-components";
import { parseISO } from "date-fns";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time
import { formatInTimeZone } from "date-fns-tz";

import { CancellationType, type CancelledShiftDetailsData } from "../../api/cancelledShiftTypes";
import { ShiftInfoRow } from "../../ShiftDetails/components/ShiftInfoRow";

interface CancellationInfoCardProps {
  readonly data: CancelledShiftDetailsData;
}

export function CancellationInfoCard({ data }: CancellationInfoCardProps) {
  const isSentHome = data.cancellationType === CancellationType.SENT_HOME;
  const cancelledAtFormatted = formatCancelledAt(
    data.cancellationDetails.cancelledAt,
    data.timezone
  );
  const leadTimeFormatted = formatLeadTime(data.leadTimeMinutes);

  return (
    <Card variant="tertiary" sx={(theme) => ({ padding: theme.spacing(5) })}>
      <Stack spacing={3}>
        <Text semibold variant="body1">
          {isSentHome ? "Sent Home Details" : "Cancellation Details"}
        </Text>
        <ShiftInfoRow
          label={isSentHome ? "Sent home at" : "Cancelled at"}
          value={cancelledAtFormatted}
        />
        <ShiftInfoRow label="Notice given" value={leadTimeFormatted} />
      </Stack>
    </Card>
  );
}

function formatCancelledAt(cancelledAt: string, timezone: string): string {
  const date = parseISO(cancelledAt);
  const dateString = formatShortDateWithWeekday(date, { timeZone: timezone });
  const timeString = formatInTimeZone(date, timezone, "h:mm a");
  return `${dateString}, ${timeString}`;
}

function formatLeadTime(minutes: number): string {
  if (minutes <= 0) {
    return "After shift started";
  }

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  if (hours === 0) {
    return `${remainingMinutes}m before shift`;
  }

  if (remainingMinutes === 0) {
    return `${hours}h before shift`;
  }

  return `${hours}h ${remainingMinutes}m before shift`;
}
